export class UploadCancelled extends Error {
  constructor() {
    super("upload-cancelled");
    this.name = "UploadCancelled";
  }
}

const isTransient = (err) => !err.response || err.response.status >= 500 || err.response.status === 429;

const waitForRetry = (delayMs, onPaused) =>
  new Promise((resolve) => {
    let settled = false;
    let timer = null;
    function settle(v) {
      if (settled) return;
      settled = true;
      window.removeEventListener("online", onOnline);
      clearTimeout(timer);
      resolve(v);
    }
    function onOnline() {
      setTimeout(() => settle("retry"), 800);
    }
    timer = setTimeout(() => settle("retry"), delayMs);
    window.addEventListener("online", onOnline);
    onPaused?.({ resumeNow: () => settle("retry"), cancel: () => settle("cancel") });
  });

export const runResumableUpload = async (steps, { onPaused, onResumed } = {}) => {
  for (const step of steps) {
    for (let attempt = 0; ; attempt++) {
      try {
        await step();
        break;
      } catch (err) {
        if (err instanceof UploadCancelled) throw err;
        if (!isTransient(err) || attempt >= 60) throw err;
        const action = await waitForRetry(Math.min(30000, 5000 * (attempt + 1)), onPaused);
        if (action === "cancel") throw new UploadCancelled();
        onResumed?.();
      }
    }
  }
};
